// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
/**
 * @hidden
 */
var ResizeHandlersVue2 = {
  name: 'KendoResizeHandlers',
  props: {
    resizable: [String, Boolean],
    rtl: Boolean
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  render: function render(createElement) {
    var h = gh || createElement;
    var _a = this.$props,
      resizable = _a.resizable,
      onPress = _a.onPress,
      rtl = _a.rtl;
    if (!resizable) {
      return null;
    }
    // const Handle = (props: { onResize: any; style: {}; d: string; onPress: any }) => (
    //    // @ts-ignore
    //   <Draggable
    //     onPress={props.onPress}
    //     onDrag={(data: any) => { props.onResize(data.event, false, props.d); }}
    //     onRelease={(data: any) => { props.onResize(data.event, true, props.d); }}
    //     >
    //     <div className={'k-resize-handle k-cursor-' + props.d + '-resize'}
    // style={{ bottom: 0, right: 0, ...props.style }} />
    //   </Draggable>
    // );
    return h("div")
    // <React.Fragment>
    //   {resizable !== 'vertical' && (
    //   <Handle
    //     onPress={onPress}
    //     onResize={this.handleResize}
    //     d="ew"
    //     style={rtl ? { top: 0, width: 9, left: 0, right: '' } : { top: 0, width: 9, right: 0, left: '' }}
    //           />
    //       )}
    //   {resizable !== 'horizontal' && (
    //   <Handle onPress={onPress} onResize={this.handleResize} d="ns" style={{ left: 0, height: 9 }} />)}
    //   {(resizable === true) && (
    //   <Handle
    //     onPress={onPress}
    //     onResize={this.handleResize}
    //     d={rtl ? 'nesw' : 'nwse'}
    //     style={rtl ? { width: 9, height: 9, right: '', left: 0 } : { width: 9, height: 9, right: 0, left: '' }}
    //           />)}
    // </React.Fragment>
    ;
  },

  methods: {
    handleResize: function handleResize(event, isEnd, direction) {
      event.originalEvent.preventDefault();
      this.$props.onResize(event, {
        end: isEnd,
        direction: direction
      });
    }
  }
};
/**
 * @hidden
 */
var ResizeHandlers = ResizeHandlersVue2;
export { ResizeHandlers, ResizeHandlersVue2 };